<script>
    /**
     * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
     * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
     *
     * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
     */
    import { __ } from '@oat-sa-private/ui-core';
</script>

<style>
    .all-items-footer {
        padding: 3.5rem 2rem;
        text-align: center;

        & p {
            text-transform: uppercase;
            font-weight: bold;
            margin: 0;
        }
    }
</style>

<footer class="all-items-footer">
    <p>{__('End of test')}</p>
</footer>
